<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-05 09:33:40
 * @最后编辑: Betway
 * @最后修改时间: 2022-09-21 13:09:01
-->
<template>
  <v-card>
    <v-card-title>
      <mrc_ess_searchInput
        :isShow="true"
        v-model="search"
        @keydown="keydown"
        @change="change"
        style="width: 100%"
        :appendShow="false"
      ></mrc_ess_searchInput>
    </v-card-title>
    <v-card-text>
      <!-- 自定义组列表 -->
      <v-card
        class="footer pl-4 pr-4"
        v-if="!deleteStatus"
        :loading="cardLoading"
      >
        <div
          style="color: #0f46c1"
          class="mb-3 mt-3 d-flex justify-space-between"
        >
          <span @click="selectAll" class="gesture">
            <v-icon
              class="material-icons"
              :style="{
                color: !selectAllStatus ? '' : '#0f46c1',
                'font-size': '20px',
              }"
              >library_add_check</v-icon
            >
            <span
              class="ml-2"
              :style="{
                color: !selectAllStatus ? '#9e9e9e' : '#0f46c1',
                'font-size': '12px',
              }"
              >{{ $t("label_chooseStaff-selectAll") }}</span
            >
          </span>
          <span
            class="gesture"
            @click="
              () => {
                deleteStatus = true;
              }
            "
          >
            <v-icon
              class="material-icons"
              style="color: #0f46c1; font-size: 21px"
              >delete</v-icon
            >
            <span class="ml-2" style="color: #0f46c1; font-size: 12px">{{
              $t("label_chooseStaff-deleteGroup")
            }}</span>
          </span>
          <!-- FF5252 -->
        </div>
        <div class="footer_box">
          <!-- my Save Group -->
          <div
            style="
              height: 24px;
              font-family: var(--body-font-family);
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 128.91%;
              display: flex;
              align-items: center;
              color: rgba(0, 0, 0, 0.38);
              flex: none;
              order: 4;
              align-self: center;
              font-size: 12px;
            "
          >
            {{ $t("label_chooseStaff-mySavedGroup") }}
          </div>
          <div
            class="d-flex mt-1 pl-2 groupItem gesture"
            v-for="(item, index) in myGroupList"
            :key="item.uuid"
            :class="item.active ? 'staffactive' : ''"
            @click="detailStaff(item, index)"
            style="
              border: 1px solid #ececec;
              height: 48px;
              font-size: 14px;
              border-radius: 4px;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span
              :style="{
                color: item.active ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                'font-size': '14px',
              }"
            >
              {{ INT(item.group_name) }}</span
            >
            <span
              class="mr-2 bgd groupItemIcon"
              @click.stop="findDetail(item)"
              style="
                width: 32px;
                height: 32px;
                border-radius: 50%;
                align-items: center;
                justify-content: center;
              "
            >
              <v-icon
                class="material-icons"
                :disabled="true"
                style="font-size: 18px"
                >search</v-icon
              >
            </span>
          </div>
          <!-- companyGroup -->
          <div
            class="mt-1"
            style="
              justify-content: space-between;
              align-items: center;
              font-size: 12px;
              height: 24px;
              font-family: var(--body-font-family);
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 128.91%;
              display: flex;
              align-items: center;
              color: rgba(0, 0, 0, 0.38);
              flex: none;
              order: 4;
              align-self: center;
            "
          >
            {{ $t("label_chooseStaff-companySavedGroup") }}
          </div>
          <div
            class="d-flex mt-1 pl-2 groupItem gesture"
            v-for="(item, index) in companyGroupList"
            :key="item.uuid"
            :class="item.active ? 'staffactive' : ''"
            @click="detailStaff(item, index)"
            style="
              border: 1px solid #ececec;
              height: 48px;
              font-size: 14px;
              border-radius: 4px;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span
              :style="{
                color: item.active ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                'font-size': '14px',
              }"
            >
              {{ INT(item.group_name) }}</span
            >
            <span
              class="mr-2 bgd groupItemIcon"
              @click.stop="findDetail(item)"
              style="
                width: 32px;
                height: 32px;
                border-radius: 50%;
                align-items: center;
                justify-content: center;
              "
            >
              <v-icon
                class="material-icons"
                :disabled="true"
                style="font-size: 18px"
                >search</v-icon
              >
            </span>
          </div>
        </div>
      </v-card>
      <!-- ----------------------------------------------- -->
      <v-card class="footer pl-4 pr-4" :loading="delCardLoading" v-else>
        <div
          style="color: #0f46c1"
          class="mb-3 mt-3 d-flex justify-space-between"
        >
          <span
            @click="
              () => {
                deleteStatus = false;
              }
            "
            class="gesture"
          >
            <v-icon
              class="material-icons"
              style="color: #0f46c1; font-size: 14px"
              >arrow_back_ios</v-icon
            >
            <span class="ml-2" style="color: #0f46c1; font-size: 12px"
              >{{ $t("label_chooseStaff-selectedBack") }}}</span
            >
          </span>
          <span @click="deleteGroup" class="gesture" v-if="deleteChecked">
            <v-icon
              class="material-icons"
              style="color: #ff5252; font-size: 21px"
              >delete</v-icon
            >
            <span class="ml-2" style="color: #ff5252; font-size: 12px">{{
              $t("label_chooseStaff-selectedDeleted")
            }}</span>
          </span>
          <span v-else></span>
        </div>
        <div class="footer_box">
          <div
            class="d-flex mt-1 pl-2 groupItem"
            v-for="item in myCheckedGroupList"
            :key="item.uuid"
            style="
              height: 48px;
              font-size: 14px;
              border-radius: 4px;
              align-items: center;
            "
          >
            <v-checkbox
              v-model="item.checked"
              @change="changeChecked"
              class="mx-2"
            ></v-checkbox>
            <div
              class="d-flex pl-2"
              :class="item.checked ? 'checkGroup' : ''"
              style="
                width: 100%;
                border: 1px solid #ececec;
                height: 48px;
                font-size: 14px;
                justify-content: space-between;
                border-radius: 4px;
                align-items: center;
              "
            >
              <span
                :style="{
                  color: item.checked ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                  'font-size': '14px',
                }"
              >
                {{ INT(item.group_name) }}</span
              >
              <span
                class="mr-2 bgd groupItemIcon gesture"
                @click.stop="findDetail(item)"
                style="
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  align-items: center;
                  justify-content: center;
                "
              >
                <v-icon
                  class="material-icons"
                  :disabled="true"
                  style="font-size: 18px"
                  >search</v-icon
                >
              </span>
            </div>
          </div>
        </div>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 *
 *
 *
 *
 * @detailStaff 获取员工的详情数据
 * @selectAll  选择列表中的全部员工
 * @getStaffList 发送请求。请求员工列表数据
 */
export default {
  components: {},
  props: {
    groupList: {
      //groupList
      type: Array,
      default: () => [],
    },
    cardLoading: {
      //列表加载状态 默认不显示
      type: Boolean,
      default: false,
    },
    delCardLoading: {
      //列表加载状态 默认不显示
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "groupList",
    event: "changeGroupList",
  },
  data() {
    return {
      search: null, //搜索值
      caseSensitive: false, //区分大小写
      open: [1, 2],
      // selectAllStatus: false,//全选状态 默认不全选
      timeout: null,
      deleteStatus: false,
      deleteChecked: null,
    };
  },
  computed: {
    myGroupList() {
      if (this.search == null || this.search == "") {
        return this.groupList.filter((item) => {
          return item.group_type == "4";
        });
      } else {
        return this.groupList.filter((item) => {
          // console.log(item.group_name.includes(this.search));
          return (
            item.group_type == "4" && item.group_name.includes(this.search)
          );
        });
      }
    },
    companyGroupList() {
      if (this.search == null || this.search == "") {
        return this.groupList.filter((item) => {
          return item.group_type == "5";
        });
      } else {
        return this.groupList.filter((item) => {
          return (
            item.group_type == "5" && item.group_name.includes(this.search)
          );
        });
      }
    },
    selectAllStatus() {
      //全选状态 默认不全选
      if (this.groupList.length > 0) {
        return this.groupList.every((item) => {
          return item.active == true;
        });
      } else {
        return false;
      }
    },
    myCheckedGroupList() {
      let arr = [];
      this.$clone(this.myGroupList).map((item) => {
        if (!item.active) {
          arr.push({ ...item, checked: false });
        }
      });
      return arr;
    },
  },
  created() {},
  watch: {},
  mounted() {
    this.changeChecked();
  },
  methods: {
    changeChecked(v) {
      this.deleteChecked = this.myCheckedGroupList.some((item) => {
        return item.checked == true;
      });
    },
    keydown(v) {
      this.search = v;
    },
    change(v) {
      this.search = v;
    },
    detailStaff(val, index) {
      //点击员工获取员工详情
      this.$emit("detailStaff", val, index);
    },
    selectAll() {
      this.$emit("selectAll", this.groupList, this.selectAllStatus);
    },
    deleteGroup() {
      //发送请求删除组
      let list = this.myCheckedGroupList.filter((item) => {
        return item.checked == true;
      });
      this.$emit("deleteGroup", list);
    },
    findDetail(item) {
      this.$emit("findDetail", item);
    },
    // getStaffList (item) {
    //   if (this.timeout !== null) clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     this.$emit('getStaffList', item)
    //   }, 500);
    // },
  },
};
</script>
 
<style scoped>
.footer {
  /* min-height: 350px; */
  /* max-height: 400px; */
  height: 409px;
  border: 1px solid #ececec;
  box-shadow: none;
  overflow-y: auto;
}
.footer_box {
  /* max-height: 400px; */
  /* overflow-y: auto; */
}
.staffactive {
  background-color: #e5eeff;
  border: 1px solid #c6dbfd;
}
.checkGroup {
  background: #e5eeff;
}
.groupItemIcon {
  display: none;
}
.groupItem:hover .groupItemIcon {
  display: flex;
  background-color: rgba(0, 0, 0, 0.1);
}
.gesture:hover {
  cursor: pointer;
}
</style>
